import UserCard from './userCard'

export default UserCard